import React from "react";
import RekognitionButton from "./RekognitionButton.js";
import AddUserModal from "./AddUserModal.js";
import { Button } from "react-bootstrap/lib/InputGroup.js";

const Header = (props) => (
  <>
    <RekognitionButton
      onClick={props.toggleRekognition}
      enabled={props.readyToStream}
    />
   
   {/* <div className="footer-add-user"> <AddUserModal onSave={props.addUser} /></div> */}
   
  </>
);

export default Header;